export const signUpModalI18n = {
  title: {
    en: 'Join the journey',
  },
  description: {
    en: 'We are building a community around healthy whole-food eating. Sign up today to stay updated about the newest features.',
  },
  reasons: {
    en: [
      '🍎 Save your favorite foods',
      '📊 Rate the foods you eat',
      '🏆 Unlock achievements (coming soon)',
      '📔 Keep a food diary (coming soon)',
      // '🤞🏻 We will never spam you',
    ],
  },
  cta: {
    en: 'Join for free',
  },
  promise: {
    en: 'No spam ever, promised. 🙏🏻',
  },
} as const;
